export enum InteractionQueueType{
  WaitingForHumanInteraction,
  Locked
}
